import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { styledReset } from '@pkg/primitives';

export const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    max-width: 567px;

    background-color: #fff;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.75);
    border-radius: 20px;

    position: relative;

    padding: 75px 30px 30px 30px;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 40px;

    @media (max-width: 1920px) {
        max-width: 468px;
    }

    @media (max-width: 1000px) {
        height: auto;
        padding: 30px;
        max-width: 100%;
    }

    @media (max-width: 500px) {
        padding: 20px;
        gap: 20px;
    }
`;

export const TextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;

    @media (max-width: 500px) {
        gap: 20px;
    }
`;

export const Title = styled.div`
    color: #090719;
    font-size: 160px;
    line-height: 80%;
    font-weight: 900;
    letter-spacing: -0.08em;
    text-transform: uppercase;
    max-width: 200px;

    @media (max-width: 1920px) {
        font-size: 138px;
    }

    @media (max-width: 1000px) {
        font-size: 106px;
        max-width: 100%;
    }

    @media (max-width: 500px) {
        font-size: 45px;
    }
`;

export const Text = styled.div`
    color: #090719;
    font-size: 30px;
    line-height: 110%;
    font-weight: 700;
    letter-spacing: -0.03em;
    max-width: 470px;

    @media (max-width: 1920px) {
        font-size: 26px;
        max-width: 360px;
    }

    @media (max-width: 1000px) {
        font-size: 20px;
        max-width: 100%;
    }

    @media (max-width: 500px) {
        font-size: 14px;
    }
`;

export const CreateButton = styled(Link)`
    width: 100%;
    height: 80px;
    background-color: #523df1;

    color: #fff;
    font-size: 20px;
    line-height: 0%;
    font-weight: 700;

    border: none;
    border-radius: 100px;
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;

    transition: background-color 0.3s ease;

    &:hover {
        background-color: rgba(82, 61, 241, 0.8);
    }

    @media (max-width: 1920px) {
        height: 58px;
        font-size: 20px;
    }

    @media (max-width: 1000px) {
        height: 50px;
        font-size: 16px;
    }
`;

export const LoginButton = styled.button`
    ${styledReset.button}

    position: absolute;
    top: 30px;
    right: 30px;

    color: #090719;
    font-size: 16px;
    line-height: 16px;
    font-weight: 700;
    letter-spacing: 0em;

    &:hover {
        text-decoration: underline;
    }

    @media (max-width: 1000px) {
        display: none;
    }
`;
